import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async triggerStartVitalsMeasure({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/androidgateway/vital/_triggerstartmeasure', options)).data
      return response
    },
    async getDeviceBattery({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/androidgateway/vital/_getdevicebattery', options)).data
      return response
    }
  }
}
